module.exports = __webpack_public_path__ + "soc-link3ss.png?e06eea5737637c73e673e4bcd2cf0c4a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/soc-link3ss.png
// module id = 79
// module chunks = 0